export const BoltIcon = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.7258 4.6857C15.8571 4.35726 15.6152 4 15.2615 4H9.36041C9.14519 4 8.95413 4.13771 8.88607 4.34189L6.2194 12.3419C6.11148 12.6657 6.35246 13 6.69374 13H9.35964C9.68493 13 9.92361 13.3057 9.84471 13.6213L8.43784 19.2487C8.31485 19.7407 8.91789 20.0821 9.27647 19.7236L18.1465 10.8536C18.4615 10.5386 18.2384 10 17.7929 10H14.3385C13.9848 10 13.7429 9.64274 13.8743 9.31431L15.7258 4.6857Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
